import { NumberInput } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import { tFormats } from '../../../infrastructure/internationalisation'
import { FormInputProps } from '../types'

export interface NumberTextFormInputMeta {
  formatParams?: Record<string, unknown>
}

export const NumberTextFormInput: FunctionComponent<
  FormInputProps<number, NumberTextFormInputMeta>
> = ({ value, onChange, meta, validation, tKey, tName, t }) => {
  const formatter = useCallback(
    (amount: number) =>
      t(tFormats('number.standard'), {
        amount,
        ...meta?.formatParams,
      }),
    [],
  )

  return (
    <NumberInput
      initialValue={value}
      onChange={onChange}
      inputPlaceholder={t(tKey(tName, 'placeholder'))}
      maxValue={validation?._self?.lessThanOrEqual as number}
      formatter={formatter}
    />
  )
}
